import Link from "next/link";
import { Icon } from "@nju/icons";
import { salesRoutes } from "@nju/routes";
import { A, Panel, Text } from "@nju/ui";

export function SalesDispositions() {
  return (
    <div data-cy="sales-dispositions-section">
      <Panel withPadding={false}>
        <Link href={salesRoutes.dyspozycjeSprzedazowe.get()} passHref={true}>
          <A size="inline" variant="simple">
            <div className="flex justify-between items-center w-full p-3 from-tablet:p-4">
              <Text
                size={{
                  "@fromTablet": "xl",
                  "@onlyMobile": "m",
                }}
                weight="bold"
              >
                Twoje dyspozycje sprzedażowe
              </Text>
              <Icon height={24} name="arrow-right" tone="accent" width={24} />
            </div>
          </A>
        </Link>
      </Panel>
    </div>
  );
}
